import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class LightElement extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.LIGHT, t.to('ライト', 'light'));
    this.setNameForCode('a-light');
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setEnvironmentColor(block);
    ShapeSettings.setElementShape(block);

    ShapeSettings.setTitleField(block, this.title);
    const lightType = new Blockly.FieldDropdown([
      [t.to('周囲', 'ambient'), 'ambient'],
      [t.to('直線的', 'directional'), 'directional'],
      [t.to('半球', 'hemisphere'), 'hemisphere'],
      [t.to('ポイント', 'point'), 'point'],
      [t.to('スポット', 'spot'), 'spot'],
    ]);

    const intensity = new Blockly.FieldTextInput('0.05');
    ShapeSettings.getDummyInput(block)
      .appendField(t.to('光の種類', 'light_type'))
      .appendField(lightType, 'typeAtt')
      .appendField(t.to('光の強さ', 'light_intensity'))
      .appendField(intensity, 'intensity');
    block.appendDummyInput().appendField(t.to('位置', 'position') + ':');
    ShapeSettings.setVR3Fields(block, 'position', 0, 0, 0);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const lightType = CodeSetting.getFieldValue(block, 'typeAtt');
    const intensity = CodeSetting.getFieldValue(block, 'intensity');

    // let inner_attr =  " type = '"  + lightType + "' ";
    // inner_attr += "intensity = '" + intensity + "' ";
    let inner_attr = '';
    inner_attr += CodeSetting.getAttributeCode('type', lightType);
    inner_attr += CodeSetting.getAttributeCode('intensity', intensity);
    inner_attr += CodeSetting.getVR3FieldValues(block, 'position');
    inner_attr += CodeSetting.getSubAttributeCode(block);
    const str = CodeSetting.getElementCode(this.name_for_code, inner_attr, block.id, '');
    return str;
  }
}
